import { useQuery } from '@tanstack/react-query';
import { objectEntries, objectFromEntries } from '../utils';
import { OrgFeaturesList, OrgService } from '../services';

const orgService = new OrgService();

type Features = keyof typeof OrgFeaturesList;

type HasFeatureAccess = {
  [Property in Features]: boolean;
};

export const useOrgFeatures = (): HasFeatureAccess => {
  const { data } = useQuery(['org'], () => orgService.get());

  const list = objectEntries(OrgFeaturesList).map<[Features, boolean]>(([key, value]) => {
    if (!data?.features) return [key, false];

    return [key, data.features.includes(value)];
  });

  return objectFromEntries(list);
};
